import { AuditOutlined } from '@ant-design/icons';

import BaseNodeContainer from '../../BaseNodeContainer';

export default function ResultNode(node: any) {

  return (
    <BaseNodeContainer
      node={node}
      title={"Resultado"}
      IconComponent={<AuditOutlined />}
      customMessageText={node.data.line_of_credit}
      onPressLink={node.onPressAddLinkedNode}
      defaultMessages={node.defaultMessages}
      defaultInputInstructions={node.defaultInputInstructions}
    />
  );
}